import React from "react";
import InfoIconFacility from "../InfoIconFacilities";
import { useTranslation } from "react-i18next";

const ToggleSwitch = ({ label, options, value, onChange, isEditing }) => {
  const { t } = useTranslation();
  return (
    <div className="toggle-switch">
      <div className="info-facility-tip">
        <InfoIconFacility text={t("TIP_BASELINE")} />
      </div>
      <label>{label}</label>

      <div className="switch">
        {options.map((option, index) => (
          <button
            key={index}
            className={`option ${value === option ? "active" : ""}`}
            onClick={() => onChange(option)}
            disabled={!isEditing}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ToggleSwitch;
